<template>
  <div>
    <NetWork v-if="networkError" @refreshs="refresh"></NetWork>
    <div
      class="enroll_wrap"
      v-else-if="
        !networkError && showEnrollContent && subSource != 'H5_GD_UNION'
      "
    >
      <div class="enroll_content" :style="{ height: H }">
        <div class="enroll_content_logo">
          <img :src="icon" />
          <p>{{ appName }}</p>
        </div>
        <div class="enroll_card">
          <div class="enroll_card_list">
            <ul>
              <li>
                <p>
                  <img src="../assets/images/money.png" />
                </p>
                <p>收入稳定</p>
              </li>
              <li>
                <p>
                  <img src="../assets/images/project.png" />
                </p>
                <p>专业培训</p>
              </li>
              <li>
                <p>
                  <img src="../assets/images/safe.png" />
                </p>
                <p>保险保障</p>
              </li>
            </ul>
          </div>
          <div class="enroll_content_btn" @click="handleOnline">在线报名</div>
        </div>
      </div>
    </div>
    <div v-else-if="!networkError && subSource == 'H5_GD_UNION'">
      <RecruitFocusIndex></RecruitFocusIndex>
    </div>
    <Loading v-else />
  </div>
</template>

<script>
import { getAppConfig } from "../apis/serviceApi";
import NetWork from "@/components/network";
import Loading from "@/components/loading";
import { handleBuryPoint } from "@/utils/tool.js";
// 聚合招募组件
import RecruitFocusIndex from "./recruitFocusIndex";
import { Toast } from "vant";
export default {
  data() {
    return {
      networkError: false,
      tenantId: "",
      appName: "",
      icon: "",
      showEnrollContent: false,
      subSource: "",
      H: document.documentElement.clientHeight + "px",
    };
  },
  components: {
    NetWork,
    Loading,
    RecruitFocusIndex,
  },
  mounted() {
    document.title = "代驾司机招募";
    // 检测断网
    window.addEventListener("offline", () => {
      console.log("已断网");
      this.networkError = true;
    });
    window.addEventListener("online", () => {
      console.log("网络已连接");
      this.networkError = false;
    });
    // 获取渠道
    handleBuryPoint("recruiting-HomePage", "show", {});
    localStorage.removeItem("spInfo");
    this.getModule();
  },
  methods: {
    // 获取云控
    async getModule() {
      const { tenantId, spLogo, spName } = this.$route.query;
      const moduleData = await getAppConfig({ tenantId });
      console.log("云控数据---", moduleData);
      if (moduleData.code === 1) {
        const val = moduleData.data;
        const finialData = {
          icon: spLogo || val.icon,
          appName: spName || val.appName,
        };
        localStorage.setItem("appName", finialData.appName);
        localStorage.setItem("spInfo", JSON.stringify({ spName, spLogo }));
        this.appName = finialData.appName;
        this.icon = finialData.icon;
        this.showEnrollContent = true;
      } else {
        Toast.fail(moduleData.msg);
      }
    },
    handleOnline() {
      handleBuryPoint("recruiting-HomePage", "signUp_Click", {});
      const {
        subSource,
        proCode,
        cityCode,
        carTeamId,
        tenantId,
        spName,
        spLogo,
        originName,
      } = this.$route.query;
      const params = {
        tenantId,
        spName,
        spLogo,
        originName,
      };
      if (subSource == "H5_SUPPLIER_SHARE") {
        (params.subSource = subSource),
          (params.proCode = proCode),
          (params.cityCode = cityCode),
          (params.carTeamId = carTeamId);
      }
      console.log(params, "--======");
      this.$router.push({
        path: "/login",
        query: {
          ...params,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.enroll_content {
  position: relative;
  background: url("../assets/images/enrollbg.png");
  background-size: 100%;
  background-repeat: no-repeat;
  .enroll_content_logo {
    display: flex;
    justify-content: center;
    position: absolute;
    top: 20px;
    left: 25px;
    img {
      width: 53px;
      height: 53px;
      box-shadow: 0px 3px 7px 0px rgba(133, 133, 133, 1);
      border-radius: 8px;
      margin-right: 14px;
    }
    font-size: 33px;
    font-weight: bold;
  }
  .enroll_card {
    width: 710px;
    height: 410px;
    background: #ffffff;
    box-shadow: 0px 2px 15px 0px rgba(187, 187, 187, 0.5);
    border-radius: 12px;
    position: relative;
    top: 660px;
    left: -355px;
    margin-left: 50%;
    .enroll_card_list {
      padding: 62px 60px;
      ul {
        display: flex;
        justify-content: space-between;
      }
      li {
        display: flex;
        flex-direction: column;
        font-size: 30px;
        align-items: center;
        p:first-child {
          width: 100px;
          height: 100px;
          img {
            width: 100%;
          }
        }
      }
    }
    .enroll_content_btn {
      width: 630px;
      height: 109px;
      background-image: linear-gradient(90deg, #2b7cff 0%, #39a8ff 100%);
      box-shadow: 0px 4px 16px 0px rgba(144, 144, 144, 0.21);
      border-radius: 58px;
      font-size: 38px;
      text-align: center;
      line-height: 116px;
      font-weight: bold;
      color: #ffffff;
      letter-spacing: 0.9px;
      margin: 0 auto;
    }
  }
}
</style>
